module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "md4": "",
      "lg2": ""
    }
  }, [_c('ul', {
    staticClass: "unstyled-list text-xs-center"
  }, _vm._l((_vm.numeroBotones), function(item, index) {
    return _c('li', {
      staticClass: "list-bots-vert"
    }, [_c('button', {
      staticClass: "bots-colors-menu",
      class: _vm.botsColorsClass(index),
      attrs: {
        "id": 'bots-num-vert' + index,
        "aria-label": 'Botón ' + (index + 1) + ' ' + (_vm.botones[index].visto ? 'visto' : 'no visto')
      },
      on: {
        "click": function($event) {
          _vm.showCont(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")])])
  }))]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "textos",
    attrs: {
      "id": "banner-slide-contain",
      "tabindex": "0"
    }
  }, [_vm._l((_vm.numeroBotones), function(item, index) {
    return (index + 1 === _vm.contenidoActual) ? _vm._t('cont' + index) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos && (_vm.contenidoActual > 0)) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70211df9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BotsNumberVert.vue
// module id = 1037
// module chunks = 1